<div class="container">
	<!-- Filters -->
	<form class="form-row align-items-end mb-3" (ngSubmit)="load()">
		<div class="form-group col-md-2">
			<label for="filter-status">Status</label>
			<select id="filter-status" class="form-control form-control-sm" [(ngModel)]="filterStatus" name="status">
				<option value="">All</option>
				<option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
			</select>
		</div>
		<div class="form-group col-md-3">
			<label for="filter-recipient">Recipient</label>
			<input id="filter-recipient" type="text" class="form-control form-control-sm"
				placeholder="email contains…" [(ngModel)]="filterRecipient" name="recipient">
		</div>
		<div class="form-group col-md-1">
			<label for="filter-case">Case</label>
			<input id="filter-case" type="number" class="form-control form-control-sm"
				[(ngModel)]="filterCaseId" name="caseId">
		</div>
		<div class="form-group col-md-2">
			<label for="filter-from">From</label>
			<input id="filter-from" type="date" class="form-control form-control-sm"
				[(ngModel)]="filterFrom" name="from">
		</div>
		<div class="form-group col-md-2">
			<label for="filter-to">To</label>
			<input id="filter-to" type="date" class="form-control form-control-sm"
				[(ngModel)]="filterTo" name="to">
		</div>
		<div class="form-group col-md-2">
			<button type="submit" class="btn btn-sm btn-primary mr-1">Filter</button>
			<button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">Clear</button>
		</div>
	</form>

	<div *ngIf="error" class="alert alert-danger py-2">{{ error }}</div>

	<div *ngIf="loading" class="text-muted py-3">Loading…</div>

	<table *ngIf="!loading" class="table table-sm table-hover">
		<thead>
			<tr>
				<th>Created</th>
				<th>Status</th>
				<th>To</th>
				<th>Subject</th>
				<th>Case</th>
				<th>Trigger</th>
				<th class="text-right">Actions</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let m of messages">
				<td class="text-nowrap">{{ m.createdAt | date:'short' }}</td>
				<td>
					<span class="badge" [ngClass]="statusBadgeClass(m.status)">{{ m.status }}</span>
					<!-- 'Hold' is redundant with the 'Held' status; only flag a redirect, which the status alone doesn't show. -->
					<span *ngIf="m.deliveryMode === 'Redirect'" class="badge badge-light ml-1" title="Delivery mode">{{ m.deliveryMode }}</span>
				</td>
				<td>
					<div>{{ m.toName }}</div>
					<small class="text-muted">{{ m.toAddress }}</small>
				</td>
				<td>{{ m.subject }}</td>
				<td>
					<a *ngIf="m.caseId != null" [routerLink]="['/review/packet', m.caseId]">#{{ m.caseId }}</a>
				</td>
				<td><small>{{ m.triggerEvent }}</small></td>
				<td class="text-right text-nowrap">
					<button class="btn btn-sm btn-link" (click)="viewBody(m)">View body</button>
					<button *ngIf="canRequeue(m)" class="btn btn-sm btn-link" (click)="requeue(m)">Requeue</button>
				</td>
			</tr>
			<tr *ngIf="messages.length === 0">
				<td colspan="7" class="text-center text-muted py-3">No notifications match the current filters.</td>
			</tr>
		</tbody>
	</table>

	<div *ngIf="loadingMore" class="text-muted text-center py-2">Loading more…</div>
	<div *ngIf="!loading && reachedEnd && messages.length > 0" class="text-muted text-center py-2 small">End of log.</div>
</div>
